import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

export interface ApiClient {
  get<P>(path: string, params?: any): Promise<P>
  post<P>(path: string, data?: any): Promise<P>
  patch<P>(path: string, data?: any): Promise<P>
  delete<P>(path: string, data?: any): Promise<P>
}

export class AxiosApiClient implements ApiClient {
  protected instance: AxiosInstance

  constructor(baseURL, auth = undefined, withCredentials = false) {
    this.instance = axios.create({
      baseURL,
      auth,
      withCredentials: withCredentials,
    })
  }

  get axiosInstance(): AxiosInstance {
    return this.instance
  }

  get<P>(path: string, params?: any, options?: AxiosRequestConfig): Promise<P> {
    return new Promise<P>((resolve, reject) => {
      this.instance
        .get(path, { ...options, params })
        .then(response => resolve(response.data))
        .catch(error => {
          reject(error)
        })
    })
  }

  post<P>(path: string, data?: any): Promise<P> {
    return new Promise<P>((resolve, reject) => {
      this.instance
        .post(path, data)
        .then(response => resolve(response.data))
        .catch(error => {
          reject(error)
        })
    })
  }

  patch<P>(path: string, data?: any): Promise<P> {
    return new Promise<P>((resolve, reject) => {
      this.instance
        .patch(path, data)
        .then(response => resolve(response.data))
        .catch(error => {
          reject(error)
        })
    })
  }

  delete<P>(path: string, data?: any): Promise<P> {
    return new Promise<P>((resolve, reject) => {
      this.instance
        .delete(path, { data: data })
        .then(response => resolve(response.data))
        .catch(error => {
          reject(error)
        })
    })
  }
}

export const googleApiClient = new AxiosApiClient(process.env.REACT_APP_GOOGLE_MAP_BASE_URL) as ApiClient



// WEBPACK FOOTER //
// ./src/utils/apiClient.ts